module.exports = __webpack_public_path__ + "static/media/icon_clock.cfe644b2.svg";